import styles from './Layout.module.scss';
import { Icon, useMobile } from '@app/ui';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { RESOURCES } from 'virtual:i18next-resources';

interface LanguageSwitcherProps {
  className?: string;
}

export const RESOURCE_KEYS = Object.keys(RESOURCES).sort((a, b) => a.localeCompare(b));

function getNextLocale(value: string) {
  return RESOURCE_KEYS[(RESOURCE_KEYS.indexOf(value) + 1) % RESOURCE_KEYS.length];
}

export function LanguageSwitcher(props: LanguageSwitcherProps) {
  const { className } = props;
  const { i18n, t } = useTranslation();
  const { isMobile } = useMobile();
  const nextLocale = getNextLocale(i18n.language);

  const handleLanguageClick = () => {
    i18n.changeLanguage(nextLocale);
  };

  return (
    <Tooltip className={className} title={t(`locale.tooltip`)}>
      <Button
        className={classNames({ [styles.flagBtnMobile]: isMobile })}
        type="link"
        aria-label={t(`locale.tooltip`)}
        icon={<Icon className={styles.flagIcon} type={i18n.language} />}
        onClick={handleLanguageClick}
      />
    </Tooltip>
  );
}
